import { skipToken, useMutation, useQuery } from '@tanstack/react-query';
import { getClientCertificate, updateClientCertificate } from './certificate.api';
import { PDFStaticBuilderProps } from '../../common/helpers/pdf-builder';

export const useClientCertificateQuery = (client_id?: string) => {
  return useQuery({
    queryKey: ['client-certificate', client_id],
    queryFn: client_id ? () => getClientCertificate(client_id) : skipToken,
    enabled: !!client_id,
  });
};

export const useUpdateClientCertificateMutation = () => {
  return useMutation({
    mutationKey: ['client-certificate', 'update'],
    mutationFn: ({
      clientCertificateId,
      client_id,
      config,
    }: {
      clientCertificateId: number | undefined;
      client_id: number;
      config: PDFStaticBuilderProps;
    }) => updateClientCertificate(clientCertificateId, client_id, config),
  });
};
